import ContactUsForm, {
	FormIdType,
} from "@components/BasicComponents/Forms/ContactUsForm/ContactUsForm"
import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Description from "@components/CustomTypography/Description/Description"
import Separator from "@components/CustomTypography/Separator/Separator"
import Title from "@components/CustomTypography/Title/Title"
import ButtonSwitcher from "@components/Switchers/ButtonSwitcher/ButtonSwitcher"
import {AdvancedSideAssetModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./OneFormSection.module.scss"

type Props = {
	data: AdvancedSideAssetModuleType
}

const OneFormSection = (props: Props) => {
	return (
		<section className={"one"} id={"book-a-demo"}>
			<div id={"bookDemo"} />
			<Separator
				size={128}
				style={{
					color: "white",
					position: "relative",
					background: "#0D1421",
				}}
				type={"padding"}
			>
				<ContainerWrapper>
					<div className={styles.mainWrapper}>
						<div className={styles.contentBox}>
							<Title
								content={props.data.sectionTitle}
								fontWeight={600}
								size={"XL"}
								type={"2"}
							/>
							<Separator size={16} />
							<Description
								content={props.data.sectionSubtitle}
								size={"XL"}
							/>
							<Separator size={64} />
							<Title
								content={props.data.mainContent?.[0]?.title}
								fontWeight={600}
								size={"XL"}
								type={"2"}
							/>
							<Separator size={16} />

							<Description
								content={props.data.mainContent?.[0]?.content}
								size={"XL"}
							/>
							<Separator size={16} />

							<div className={styles.content_buttons_box}>
								<ButtonSwitcher
									buttonsList={props.data.mainContent?.[0]}
								/>
							</div>
						</div>

						<div className={styles.formBox}>
							<Separator customPadding={"0"}>
								<ContactUsForm
									container={{
										style: {
											background: "transparent",
											color: "white",
										},
									}}
									form={FormIdType.ONE_DEFAULT}
								/>
							</Separator>
						</div>
					</div>
				</ContainerWrapper>
			</Separator>
		</section>
	)
}

export default OneFormSection
